export default function SuccessStatusIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width='12'
      height='12'
      viewBox='0 0 24 24'
      fill='white'
    >
      <path d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' />
    </svg>
  );
}
